var $0ebd4a27fdd91006$exports = {};
$0ebd4a27fdd91006$exports = {
    "clear": `Limpar`,
    "invalid": `(inv\xe1lido)`,
    "loading": `Carregando...`,
    "noResults": `Nenhum resultado`,
    "valid": `(v\xe1lido)`
};


export {$0ebd4a27fdd91006$exports as default};
//# sourceMappingURL=pt-BR.mjs.map
